import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { useLenis } from "./hooks/useLenis";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import Home from "./pages/Home";
import Checkout from "./pages/Checkout";
import OrderResult from "./pages/OrderResult";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

const Shell = () => {
  useLenis();
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/commande" element={<Checkout />} />
        <Route path="/commande/confirmation" element={<OrderResult />} />
        <Route path="/paiement/succes" element={<OrderResult />} />
        <Route path="/paiement/annule" element={<OrderResult />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Footer />
      <CartDrawer />
      <Toaster position="bottom-right" richColors toastOptions={{ style: { fontFamily: "IBM Plex Sans" } }} />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Shell />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
